import { useEffect } from 'react';
import { useClearCache } from 'react-clear-cache';
import PackageJson from '../package.json';

const ClearingCache = () => {
  const { emptyCacheStorage } = useClearCache();
  
  useEffect(() => {
    const version = PackageJson.version ? localStorage.getItem('version') : '';
    // console.log(
    //   'ClearCache',
    //   version,
    //   PackageJson.version,
    //   version !== PackageJson.version,
    //   window,
    // );

    if (version !== PackageJson.version) {
      // console.log('1 ==> ClearCache is OK!!!', window);
      emptyCacheStorage();
      window.location.reload(true);
      if ('caches' in window) {
        caches.keys().then((names) => {
          // console.log('3 ==> ClearCache is OK!!!', names);
          names.forEach((name) => caches.delete(name));
        });
        window.location.reload(true);
        // console.log('4 ==> ClearCache is OK!!!');
      }
      localStorage.removeItem('version');
      localStorage.setItem('version', PackageJson.version);
    }
  }, [emptyCacheStorage]);
};

export default ClearingCache;
